import React from 'react';
import { PlayIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { channel } from '../data/channel';
import { cleanTitle, formatViews, videoThumbnail, videoUrl } from '../utils/video';
import type { Video } from '../types/video';
interface ShortsRowProps {
  shorts: Video[];
}
export function ShortsRow({
  shorts
}: ShortsRowProps) {
  if (shorts.length === 0) return null;
  return <section aria-labelledby="shorts-title" className="pb-20 md:pb-28" data-id="element-110" data-mp="3ovqwvu7bdpjs">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-111" data-mp="3tv3h076swiio">
        <SectionHeading id="shorts-title" title="Хвилина з походу" subtitle="Короткі історії зі стежки — для тих, хто має лише 60 секунд." link={{
        href: `${channel.url}/shorts`,
        label: 'Усі Shorts'
      }} data-id="element-112" data-mp="3ttk14hp249hf" />
      </div>

      <ul className="mx-auto mt-10 flex max-w-7xl snap-x snap-mandatory gap-4 overflow-x-auto scroll-px-5 px-5 pb-5 md:scroll-px-8 md:px-8 shorts-scroll" data-id="element-113" data-mp="bip05kbeak44">
        {shorts.map(short => <li key={short.id} className="w-[46%] shrink-0 snap-start sm:w-[30%] lg:w-[calc((100%-5rem)/6)]" data-id="element-114" data-mp="jucilkzzet6t">
            <a href={videoUrl(short)} target="_blank" rel="noopener noreferrer" className="group block rounded-2xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ember" data-id="element-115" data-mp="fqwnwu7h32wr">
              <div className="relative aspect-[9/16] overflow-hidden rounded-2xl bg-surface" data-id="element-116" data-mp="13g8t7izoiqts">
                <img src={videoThumbnail(short)} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-117" data-mp="yhxn9jci90gu" />
                <span className="absolute left-2.5 top-2.5 inline-flex items-center gap-1 rounded-md bg-ink/85 px-1.5 py-0.5 text-xs font-bold text-paper" data-id="element-118" data-mp="1m7rzbyp02l01">
                  <PlayIcon className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-119" data-mp="1hfgz0uqckx6y" />
                  {formatViews(short.views, false)}
                </span>
              </div>
              <h3 className="mt-3 line-clamp-2 text-sm font-semibold leading-snug text-paper transition-colors duration-150 group-hover:text-ember" data-id="element-120" data-mp="3fpfp8c78ilir">
                {cleanTitle(short.title)}
              </h3>
            </a>
          </li>)}
      </ul>
    </section>;
}